import { Types } from "../../constants/index.js";
import SubField from "../builders/SubField.js";
export default SubField({
  objectType: Types.deviceType,
  baseAttrName: 'firmwareUpgradeStrategy',
  baseAttrField: 'firmwareUpgradeStrategy',
  field: 'type',
  creatable: true,
  editable: false,
  displayName: 'Firmware Upgrade Strategy Type',
  valueType: 'string',
  createOptions: {
    editor: 'enum',
    editorProps: {
      get values() {
        return [{
          value: 'application',
          name: 'Application'
        }, {
          value: 'component',
          name: 'Component'
        }];
      }
    }
  }
});